import i18n from 'services/base/i18n';

export default {
  // Text describing what the pangolin is
  smartFirewall: () => i18n.pgettext('Pages|Introduction', 'SMART FIREWALL'),

  // Text for the link to the registration page
  register: () => i18n.pgettext('Pages|Introduction', 'REGISTER'),

  // Text for the link to the login page
  login: () => i18n.pgettext('Pages|Introduction', 'LOGIN'),
};